import { Request } from 'shared/tools/request';

export const uploadLotImage = (id, data) => Request.post(`/api/parsed-lot/${id}/image`, { data });

export const deleteLotImage = id => Request.delete(`/api/parsed-lot/${id}/image`);

export const updateLot = (id, data) => Request.put(`/api/parsed-lot/${id}`, { data });

export const updateLotPartial = (id, data) => Request.put(`/api/parsed-lot/update-partial/${id}`, { data });

export const addLot = data => Request.post(`/api/parsed-lot/add`, { data });
